import './index.css'

const index = ({ logo }) => {
  return (
    <div className="Footer-container">
      Made with love at <span>-LUCKY DICE FILMS-</span> © 2022
    </div>
  )
}

export default index